import { WindowMessage } from "src/coreTypes";

export function sendMessageTop(msg: WindowMessage) {
    window.top.postMessage(msg, '*');
}